// extracted by mini-css-extract-plugin
export default {"body":"styles_body__QBRSn","content":"styles_content__pvVwi","text":"styles_text__PMj+y","cta":"styles_cta__EUMwD","header":"styles_header__4E-Os"};